module.exports = __webpack_public_path__ + "img/privilege5.c23190cd.png";